"use strict";

App.Pages.PollsOverview = class PollsOverview extends PF.Page
{

	static get options()
	{
		return {
			rights: {
				user: true
			},
			path: '/polls-overview',
			nameRu: 'Опросы - Обзор',
		};
	}

	static get template()
	{
		//language=HTML
		return /*html*/`
			<div class="page navbar-fixed">
				<div class="page-content ptr-content" pf="pageContent">

					<div class="page-header">
						<h3 pf="stellaName">Обзор</h3>
					</div>

					<div class="row resizable" pf="plots">
						<div class="row">
							<div class="col-100 card">
								<div class="card-header card-content-padding">
									Статистика
								</div>
								<div class="card-content">
                                    <div pf="totalPassing" class="col-33 pie"></div>
								</div>
								<div class="card-footer">
									<button class="button" type="button" pf="buttonPolls">Страница опросов</button> |
									<button class="button" type="button" pf="buttonDownload">Скачать результаты</button>
								</div>
							</div>
							<div class="col-100 card">
								<div class="card-header card-content-padding">
									Настройки
								</div>
								<div class="card-content">
									<form pf="formC">
										<div class="row resizable">
											<div class="col-20"><br/>
												Время простоя (в сек):
											</div>
											<div class="col-50">
												<input pf="value"/> 
											</div>
											<div class="col-30"><br/>
												<button class="button-fill button" pf="saveС">Сохранить</button>
											</div>
										</div>
									</form>
								</div>
								<div class="card-content">
									<div class="row resizable">
										<div class="col-20">
											Формат прохождения:
										</div>
										<div class="col-40">
											<button class="button" type="button" pf="questionsScroll">Опросы лентой</button>
										</div>
										<div class="col-40">
											<button class="button" type="button" pf="questionsStep">Опросы по странично</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		`;

	}

	init()
	{
		super.init();

		this.dom.buttonDownload.on("click", () =>
		{
			window.location.replace("/questions/result");
		});
		this.dom.buttonPolls.on("click", () =>
		{
			app.router.navigate('/polls');
		});
		//
		this.setting();
	}

	setting()
	{
		this.model = new PF.Model({
			raw: {
				value: 30,
				id: 1,
			}
		});
		app.request('/settings/get', { target: 'questions-timer' }, (response) =>
		{
			this.response = response;
			if (this.response.status != 'FAIL')
			{
				if (this.response.data != null)
				{
					this.model.value = this.response.data;
				}
			} else
			{
				this.model = new PF.Model({
					raw: {
						dt: DateTime.local(),
						questionsNumber: 1,
						step: 1,
					}
				});
			}
		});

		this.formC = new PF.Form({
			dom: { element: this.dom.formC },
			model: this.model,
			toastOnSave: false,
			fieldsConfig: {
				// value: valueClass,
				value: {
					class: PF.Field.Int,
					key: 'value'
				},
			}
		});
		this.dom.saveС.on("click", () =>
		{
			this.message = {
				target: 'questions-timer',
				value: this.model.value,
			}
			this.setValue();
		});
		//

		this.questionsPage = 'poll-questions-step';
		this.dom.questionsStep.on("click", () =>
		{
			this.message = {
				target: 'questions',
				value: 'poll-questions-step',
			}
			this.setValue();
		});
		this.dom.questionsScroll.on("click", () =>
		{
			this.message = {
				target: 'questions',
				value: 'poll-questions-scroll',
			}
			this.setValue();
		});
		this.bindDom({ questionsStep: 'class:button-active' }, 'questionsPage', (s) => s === 'poll-questions-step');
		this.bindDom({ questionsScroll: 'class:button-active' }, 'questionsPage', (s) => s === 'poll-questions-scroll');
		app.request('/settings/get', { target: 'questions' }, (response) =>
		{
			this.response = response;
			if (this.response.status != 'FAIL')
			{
				if (this.response.data != null)
				{
					this.questionsPage = this.response.data;
				} else
				{
					this.questionsPage = 'poll-questions-step';
				}
			}
		});
		//
		this.charts();
	}

	setValue(callback = ((e) => { })) 
	{
		app.request('/settings/set', this.message, (response) =>
		{
			// this.response = JSON.parse(response);
			this.response = response;
			console.log(this.response);
			if (this.response.data != undefined)
			{
				this.questionsPage = this.response.data;
			}
			callback(this.response);
		});
	}

	charts()
	{
		this.series = {};
		this.optionPie = {
			chart: {
				height: 350,
				type: 'pie',
			},
			tooltip: {
				pointFormat: '<b>Кол-во: {point.y} ({point.percentage:.1f} %)</b>'
			},
			accessibility: {
				point: {
					valueSuffix: 'шт'
				}
			},
			plotOptions: {
				pie: {
					allowPointSelect: true,
					cursor: 'pointer',
					dataLabels: {
						enabled: true,
                		distance: -40,
						format: '{point.y}'
					},
					showInLegend: true,
					center: ["50%", 100]
				}
			},
			legend: {
				itemStyle: {
					fontSize: '9px',
				},
				align: 'center',
				// enabled: true,
				// layout: 'vertical',
				// verticalAlign: 'bottom',
			},
		};
		this.chartsAll();
		Util.interval(600000, () => this.chartsAll());
	}

	chartsAll()
	{
		this.dom.totalPassing.empty();
		app.request('/questions/statistic', [], (response) =>
		{
			let responseAll = response;
			if (responseAll.status != 'FAIL')
			{
				this.series = responseAll.data.series;
			}
			let emotions = new Highcharts.chart(this.dom.totalPassing.node, {
				title: {
					useHTML: true,
					//language=HTML
					text: `<h4>Дано ответов</h4>`,
					align: 'left',
				},
				series: [this.series],
				...this.optionPie
			});
		});
	} // chartsAll
};